
import { defineComponent } from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import TotalizadorDecorado from '@/core/components/Tela/TotalizadorDecorado.vue';

export default defineComponent({
  name: 'ControleCaixasTotalizadores',
  props: {
    saldoInicial: {
      type: Number,
      required: true,
    },
    totalEntradas: {
      type: Number,
      required: true,
    },
    totalVendas: {
      type: Number,
      required: true,
    },
    totalCancelado: {
      type: Number,
      required: true,
    },
    totalDevolvido: {
      type: Number,
      required: true,
    },
    saldoFinal: {
      type: Number,
      required: true,
    },
    totalTransferido: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card,
    TotalizadorDecorado,
  },
  setup(props) {
    return {
      props,
    };
  },
});
